import { change } from 'redux-form';

import { ThunkResult } from 'app/store/helpers';
import { FormsEnum, TravelFiltersEnum } from 'app/shared/enums';
import { TravelOfferFiltersFormInterface } from './state.interfaces';

export const EMPTY_TRAVEL_DETAILED_FILTERS: Pick<
  TravelOfferFiltersFormInterface,
  TravelFiltersEnum
> = {
  [TravelFiltersEnum.TreatmentCost]: undefined,
  [TravelFiltersEnum.Oc]: undefined,
  [TravelFiltersEnum.Nnw]: undefined,
  [TravelFiltersEnum.SportsInsurance]: undefined,
  [TravelFiltersEnum.LuggageInsurance]: undefined,
  [TravelFiltersEnum.SportEquipmentInsurance]: undefined,
  [TravelFiltersEnum.CoverageOfRescueCosts]: undefined,
  [TravelFiltersEnum.UnlimitedMedicalTransport]: undefined,
};

export const clearTravelDetailedFilters = (
  values?: Partial<Pick<TravelOfferFiltersFormInterface, TravelFiltersEnum>>
): ThunkResult<void> => (dispatch) => {
  const toApply = values ?? EMPTY_TRAVEL_DETAILED_FILTERS;

  (Object.keys(toApply) as Array<TravelFiltersEnum>).forEach((field) => {
    dispatch(change(FormsEnum.TravelResultsFilters, field, toApply[field]));
  });
};
